import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ServerService } from '../../service/server/server.service';
import { Params, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { UserVideoComponent } from '../../user/user-video/user-video.component';
import { MessageService } from '../../service/message/message.service';
import { PayDetaileComponent } from "../../finance/finance-pay/pay-detaile/pay-detaile.component";
import { InvoiceBuyDetaileComponent } from '../invoice-buy-detaile/invoice-buy-detaile.component';
import { InvoiceBuySmsComponent } from '../invoice-buy-sms/invoice-buy-sms.component';
import { InvoiceBuyFilterComponent } from '../invoice-buy-filter/invoice-buy-filter.component'

@Component({
  selector: 'app-invoice-buy-list',
  templateUrl: './invoice-buy-list.component.html',
  styleUrls: ['./invoice-buy-list.component.scss']
})
export class InvoiceBuyListComponent implements OnInit, OnDestroy {
  //**********************************************************
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public lang: any = JSON.parse(<any>localStorage.getItem('lang'));
  public user_id: number;
  public loading: boolean = false;
  public show_excel: boolean = false;
  public access_insert_finance: boolean = false;
  public access_invoice_sale: boolean = false;
  public access_invoice_buy: boolean = false;
  public access_invoice_return_buy: boolean = false;
  public indeterminate: boolean = false;
  public checked: boolean = false;
  public page: number = 1;
  public excel: number = 1;
  public count_total: number = 1;
  public sum: number = 0;
  public invoice_type_id: number = 0;
  public asc_desc: string = 'asc';
  public list_record: any = [];
  public search_array: any = [];
  public selected_record: any = [];
  public server!: string;
  public server_main!: string;
  public site!: string;
  public subscription: Subscription | any;
  public customer_title!: string;
  public customer_id!: number;
  public task_type!: number;
  public confirm_delete!: boolean;
  public page_number_first!: number;
  public page_number_second!: number;
  public code!: any;
  public export_code!: string;
  public type_task!: number;
  public type!: number;
  public type_search!: number;
  public search_all!: string;
  public creator!: number;
  public video!: string;
  public access_service!: number;
  public level!: number;
  public x!: any;
  public index!: number;
  public order!: string;
  public query_user!: number;
  public wharehouse_invoice_type!: number;
  public back_i!: number;
  public expire!: boolean;
  public path_export!: string;
  public id!: number;
  public pre_status!: boolean;
  public next_status!: boolean;
  public new_status!: boolean;
  public new_invoice_id!: number;
  public mat_table_selectedRow!: any;
  public mat_table_hoverRow!: any;
  public dataSource!: any;
  public displayedColumns = ['row', 'invoice_date', 'user', 'price', 'invoice_number', 'settlement', 'comment', 'pay', 'operation'];
  //************** */
  constructor(
    public serverService: ServerService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public matSnackBar: MatSnackBar,
    public messageService: MessageService,
    public dialog: MatDialog) {
    this.server = this.serverService.get_server();
    this.server_main = this.serverService.get_server_main();
    this.site = this.serverService.get_site();
  }
  ngOnInit() {
    this.serverService.status1(2);
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.activatedRoute.queryParams.subscribe(
      (params) => {
        this.page = Number(params['page']);
        if (params['back_i']) this.back_i = params['back_i'];
        if (params['user']) this.query_user = params['user'];
      }
    );
    this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.code = params['id'];
        if (!this.page) this.page = 1;
        if (params['type']) this.invoice_type_id = params['type'];
        this.check_access(4, 1, 0, 1, 1);
      }
    )
    this.change_access_insert_finance();
    //**************
  }//end ngOnInit
  change_access_insert_finance() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6504, user_id: this.user_id }).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.access_insert_finance = res['result'][0].access;
            this.access_invoice_sale = res['result'][0].access_invoice_sale;
            this.access_invoice_buy = res['result'][0].access_invoice_buy;
            this.access_invoice_return_buy = res['result'][0].access_invoice_return_buy;
          } else {
            this.access_insert_finance = false;
            this.access_invoice_sale = false;
            this.access_invoice_buy = false;
            this.access_invoice_return_buy = false;
          }
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  //****************************************************************************
  check_access(type_task: any, page: number, id: any, excel: number, loading: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, type: 'user', user_id: this.user_id, id: this.code }).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          this.creator = res['creator'];
          this.level = res['level'];
          this.path_export = res['path_export'];
          this.access_service = res['result'][0].count;
          this.check_access2(type_task, page, id, excel, loading, res['result'][0].count);
        }//end if
        else {
          this.message(true, this.messageService.access2(), 1, this.messageService.close());
        }
      }
    )
  }
  check_access2(type_task: any, page: number, id: any, excel: number, loading: number, access_service: number): any {
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', { 'address': 6, user_id: this.creator, id: this.code }).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          else if (this.level == 3 && access_service == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          this.video = res['result'][0].video;
          this.expire = res['expire'];
          this.loading = false;
          if (type_task == 1) {
            if (this.expire == true) {
              this.message(true, this.messageService.expire(), 1, this.messageService.close());
              return false;
            } else {
              this.new();
            }
          }
          if (type_task == 3) {
            this.delete(id);
          }
          if (type_task == 4) {
            this.load_data(page, excel, loading, -1);
          }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  sort(sort: string, asc_desc: string) {
    if (asc_desc == 'asc') this.asc_desc = 'desc';
    else this.asc_desc = 'asc';
    this.order = sort + " " + this.asc_desc;
    this.load_data(1, 1, 1, -1);
  }
  reset_sort(sort: string, asc_desc: string) {
    this.order = sort + " " + asc_desc;
    this.load_data(1, 1, 1, -1);
  }
  load_data(page: number, excel: number, loading: number, changedRows: number): any {
    if (loading == 1) this.loading = true;
    if (page == 2) { this.page = this.page + 1; }
    if (page == 4) { this.page = Math.ceil(this.count_total / 20); }
    if (page == 3) { this.page = this.page - 1; }
    if (page == 5) { this.page = 1; }
    if (page == 1) { this.page = 1; }
    var obj = {
      'address': 7257,
      "page": this.page,
      'type': this.type,
      'excel': excel,
      'user_id': this.user_id,
      'search': this.search_array,
      'search_all': this.search_all,
      'changedRows': changedRows,
      'invoice_type_id': this.invoice_type_id,
      'creator': this.creator,
      'path_export': this.path_export,
      'access_invoice_sale': this.access_invoice_sale,
      'access_invoice_buy': this.access_invoice_buy,
      'access_invoice_return_buy': this.access_invoice_return_buy,
      'order': this.order,
      'query_user': this.query_user
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (excel == 1) {
            if (changedRows == -1) this.list_record = [];
            if (changedRows > 0 || changedRows == -1) {
              for (var i = 0; i < res['num']; i++) {
                this.list_record.push(res['result'][i]);
              }//end for
            }
            this.dataSource = new MatTableDataSource(this.list_record);
            this.count_total = res['count'];
            this.sum = res['sum'];
            this.pages(0);
            this.serverService.send_services_id(this.code);
            this.serverService.send_reset({});
            this.serverService.change_window_resize(2, '', 0);
          }
          else if (excel == 2) {
            this.export_excel(res['export_code']);
          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }//end else
      }//end res:Response
    ) //ens dubscribe
  }//end load data
  export_excel(code: number) {
    if (code > 0) {
      var x = <any>document.getElementById("excel");
      x.href = this.site + "/export/" + code + ".xlsx";
      x.click();
    }
  }
  pages(count: number) {
    this.count_total = this.count_total + count;
    this.page_number_first = this.page * 20 - 19;
    this.page_number_second = this.page * 20;
    if (this.page_number_first == 1) { this.pre_status = true; this.new_status = false; }
    else { this.pre_status = false; this.new_status = true; }
    if (this.list_record.length < 20 || (this.page * 20 >= this.count_total)) {
      this.page_number_second = this.count_total;
      this.next_status = true;
    }//end if
    else { this.next_status = false; }
  }
  //***************************************************************************
  new(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 7258, creator: this.creator, user_id: this.user_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) this.new_invoice_id = Number(res['result'][0].wharehouse_invoice_number) + 1;
          else this.new_invoice_id = 1;
          this.open_detaile(-1, 2, res['id'], 3);
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  open_detaile(i: number, type_task: number, id: number, trash: number) {
    var modal: any = InvoiceBuyDetaileComponent;
    if (type_task == 3) {
      modal = InvoiceBuyFilterComponent;
    }
    var width = '85rem';
    if (type_task == 3) {
      width = '30rem';
    }
    const dialogRef = this.dialog.open(modal, {
      width: width,
      height: 'auto',
      disableClose: true,
      data: {
        type_task: type_task,
        id: id,
        i: i,
        search_array: this.search_array,
        new_invoice_id: this.new_invoice_id,
        code: this.code,
        trash: trash,
        creator: this.creator
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          if (type_task == 1 || i == -1) {
            this.list_record.unshift(res.result);
            this.pages(1);
            if (this.list_record.length == 21) {
              this.list_record.splice(20, 1);
            }
            this.dataSource.data = this.list_record;
            if (res.result.confirm_sms == true) {
              var message = "فاکتور با موفقیت ذخیره شد . و پیامک برای مشتری ارسال شد";
              this.message(true, this.messageService.message(message), 1, this.messageService.close());
              this.send_sms_after_new(0)
            } else {
              var message = "فاکتور با موفقیت ذخیره شد . اما پیامک برای مشتری ارسال نشد";
              this.message(true, this.messageService.message(message), 1, this.messageService.close());
            }
            if (res.type_save == 'insert_finance' && this.access_insert_finance == true) {
              this.pay(res.result.user_id, res.result.wharehouse_invoice_amount, res.result.wharehouse_invoice_number);
            }
          }
          else if (type_task == 2) {
            this.list_record[i].wharehouse_invoice_token_sms = res.result.wharehouse_invoice_token_sms;
            this.list_record[i].wharehouse_invoice_amount = res.result.wharehouse_invoice_amount;
            this.list_record[i].user_cellphone = res.result.user_cellphone;
            this.list_record[i].wharehouse_invoice_type = res.result.wharehouse_invoice_type;
            this.list_record[i].wharehouse_invoice_title = res.result.wharehouse_invoice_title;
            this.list_record[i].wharehouse_invoice_number = res.result.wharehouse_invoice_number;
            this.list_record[i].wharehouse_invoice_comment = res.result.wharehouse_invoice_comment;
            this.list_record[i].wharehouse_invoice_date3 = res.result.wharehouse_invoice_date3;
            this.list_record[i].user_title = res.result.user_title;
            this.list_record[i].user_id = res.result.user_id;
            this.list_record[i].wharehouse_invoice_settlement_date = res.result.wharehouse_invoice_settlement_date;
            this.list_record[i].site_currency_title = res.result.site_currency_title;
            this.list_record[i].status_title = res.result.status_title;
            if (res.temp_user != res.user) {
              this.change_token(i, id, res.type_save);
            }
            if (res.type_save == 'insert_finance' && this.access_insert_finance == true) {
              this.pay(res.result.user_id, res.result.wharehouse_invoice_amount, res.result.wharehouse_invoice_number);
            }
          }
          else if (type_task == 3) {
            var excel = res.export_excel;
            this.search_array = [];
            this.search_array = res;
            this.check_access(4, 1, 0, excel, 1);
          }
        }
      }
    )
  }
  change_token(i: number, id: number, type_save: string) {
    var token = Math.floor(Math.random() * 99999999999999);
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6756, id: id, token: token }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.list_record[i].wharehouse_invoice_token_sms = token;
          if (type_save == 'insert_finance_and_print') {
            window.open(this.serverService.get_my_domain() + "/invoice/" + this.list_record[i].wharehouse_invoice_id + "/" + this.list_record[i].wharehouse_invoice_token_sms, "_blank");
          }
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  get_bg(id: number) {
    this.id = id;
  }
  //*******************************************************************************
  delete(id: number): any {
    var confirm_delete;
    confirm_delete = window.confirm(this.messageService.message_delete_accept());
    this.loading = false;
    if (confirm_delete == true) {
      this.loading = true;
      var obj = {
        'address': 7268,
        "user_id": this.user_id,
        "creator": this.creator,
        'id': id,
      }
      this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
        (res: any) => {
          if (res['status'] == 1) {
            this.list_record.splice(this.list_record.findIndex((index: any) => index.wharehouse_invoice_id == id), 1);
            this.dataSource.data = this.list_record;
            this.pages(-res['result'].changedRows);
            this.load_data(this.page, 1, 2, res['result'].changedRows);
            this.message(false, "", 1, this.messageService.close());
          }//end if
          else if (res['status'] == 4) {
            var message = "این رکورد دارای آیتم های خرید می باشد و قادر به حذف نیستید";
            this.message(true, this.messageService.message(message), 1, this.messageService.close());
          }
          else {
            this.message(true, this.messageService.message_error(), 1, this.serverService.message_action());
          }//end else
        }//end res:Response
      )//end this.subscription
    }//end this.confirm_delete == true    
  }//end delete
  //**************************************************************************************************************************************** */
  pay(user: number, price: number, invoice_number: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 7018,
      'user': user,
      'user_id': this.user_id,
      'creator': this.creator,
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.open_financial(res['id'], price, invoice_number);
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  open_financial(id: number, price: number, invoice_number: number) {
    const dialogRef = this.dialog.open(PayDetaileComponent, {
      width: '85rem',
      height: 'auto',
      data: { type_task: 2, id: id, code: this.code, document: 1, sum: price, ref: 'invoice', invoice_number: invoice_number, invoice_title: 'فاکتور خرید', i: -1 }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {

      }
    )
  }
  //*************************************************************************قسمت پایین برای ارسال پیامک می باشد***************************************** */
  open_sms() {
    this.dialog.open(InvoiceBuySmsComponent, {
      width: '25rem',
      height: 'auto',
      data: { invoice_id: this.x.wharehouse_invoice_id, code: this.code, creator: this.creator }
    })
  }
  send_sms_after_new(i: number): any {
    var token2 = this.serverService.get_my_domain() + "/recipt-printer-invoice/" + this.list_record[i].wharehouse_invoice_id;
    var obj = {
      'address': 6514,
      'cellphone': this.list_record[i].user_cellPhone,
      'type_title': "خرید",
      'token2': token2,
      'token_sms': this.list_record[i].wharehouse_invoice_token_sms,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
        this.serverService.send_sms_charge();
      }
    )
  }//end if
  //****************************************************************************************************************** */
  get_customer(id: number) {
    this.customer_id = id;
  }
  //*******************************************************************************
  change_resize() {
    //this.serverService.change_window_resize(1,'',0);
  }//end change_resize
  open_video() {
    this.dialog.open(UserVideoComponent, {
      width: '45rem',
      height: 'auto',
      data: { id: this.code }
    })
  }
  get_menu(i: number, x: any) {
    this.x = x;
    this.index = i;
    this.wharehouse_invoice_type = x.wharehouse_invoice_type;
  }
  show_factor1() {
    window.open(this.serverService.get_my_domain() + "/invoice/" + this.x.wharehouse_invoice_id + "/" + this.x.wharehouse_invoice_token_sms, "_blank");
  }
  //*******************************************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 3000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
